import makeTable from "./makeTable";

const agentGroup = makeTable({
	allIds: ["title", "notes", "amount"],
	i18tPath: (id) => `tableColumns.customers.agentGroups.${id}`,
});

export default agentGroup;
